import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ShowcaseCategoryView } from "./ShowcaseCategoryView";
import { ShowcaseCategoryViewStore } from "../../store/ShowcaseCategoryViewStore";
import { useStore } from "../../../../hooks";

export const ShowcaseCategoryViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/showcaseCategory/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ShowcaseCategoryViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ShowcaseCategoryView showcaseCategoryViewStore={store} />
      </PageLayout>
    </div>
  );
});
